import store from '@/store';

const canAccessReports = async (to, from, next) => {
  const canAccess = store.state.app.modulosPerfisLiberados.tabelas_liberadas.length > 0 ? true : false;
  if (!canAccess) next({ name: 'Home' });
  else next();
};

export { canAccessReports };